import { deviceViewports } from '../constants/DeviceViewports';
import useWindowSize from './useWindowSize';

function useTabletL() {
  const { width } = useWindowSize();
  return width < deviceViewports.tabletL;
}

export default useTabletL;
